import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function Closing() {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate(`/card/${sessionId}`), 2400);
    return () => clearTimeout(t);
  }, [navigate, sessionId]);

  return (
    <div className="flex flex-col min-h-[100dvh] items-center justify-center px-10">
      <p
        data-testid="closing-line"
        className="font-serif italic text-3xl text-still-fg/90 text-center leading-relaxed animate-fade-up"
      >
        Take care of yourself.
      </p>
    </div>
  );
}
